import Home from '../lib/views/Home.svelte';
import NotFound from '../lib/views/NotFound.svelte';
import Loading from '../lib/components/Loading.svelte';
import { replace } from 'svelte-spa-router';
import { wrap } from 'svelte-spa-router/wrap';
import { fetchDataVarious, checkAuth } from '../lib/scripts/util';
import { authStore } from '../store/auth';
import { get } from 'svelte/store';

// import Login from '../lib/views/Login.svelte';
// import AdminLayout from '../lib/layouts/AdminLayout.svelte';

export const routes = {
	// Exact path
	'/': Home,
	'/login': wrap({
		asyncComponent: () => import('../lib/views/Login.svelte'),
		loadingComponent: Loading,
		conditions: [
			async detail => {
				const auth_token = get(authStore);
				if (auth_token) {
					replace('/admin');
					return false;
				} else {
					return true;
				}
			},
		],
	}),

	// Using named parameters, with last being optional
	'/admin': wrap({
		// Use a dynamically-loaded component for this
		asyncComponent: () => import('../lib/views/Admin.svelte'),
		// Adding one pre-condition that's an async function
		loadingComponent: Loading,
		conditions: [
			async detail => {
				return checkAuth();
				// Make a network request, which are async operations
				// Return true to continue loading the component, or false otherwise
			},
		],
	}),

	'/admin/model-year': wrap({
		asyncComponent: () => import('../lib/views/maintenance/ModelYearMaintenance.svelte'),
		loadingComponent: Loading,
		conditions: [
			async detail => {
				return checkAuth();
			},
		],
	}),
	'/admin/maker': wrap({
		asyncComponent: () => import('../lib/views/maintenance/MakerMaintenance.svelte'),
		loadingComponent: Loading,
		conditions: [
			async detail => {
				return checkAuth();
			},
		],
	}),
	'/admin/maker-detail-chevrolet': wrap({
		asyncComponent: () => import('../lib/views/maintenance/MakerDetailChevroletMaintenance.svelte'),
		loadingComponent: Loading,
		conditions: [
			async detail => {
				return checkAuth();
			},
		],
	}),
	'/admin/maker-detail-chrysler': wrap({
		asyncComponent: () => import('../lib/views/maintenance/MakerDetailChryslerMaintenance.svelte'),
		loadingComponent: Loading,
		conditions: [
			async detail => {
				return checkAuth();
			},
		],
	}),

	'/admin/vehicle': wrap({
		asyncComponent: () => import('../lib/views/maintenance/VehicleMaintenance.svelte'),
		loadingComponent: Loading,
		conditions: [
			async detail => {
				return checkAuth();
			},
		],
	}),

	// Wildcard parameter
	// '/book/*': Book,

	// Catch-all
	// This is optional, but if present it must be the last
	'*': NotFound,
};
